/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './footer.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../src/app/footer/footer.component';
const styles_FooterComponent:any[] = [i0.styles];
export const RenderType_FooterComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_FooterComponent,data:{}});
export function View_FooterComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted((null as any),['A clone of '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),1,'a',[['class','link'],['target','_blank']],[[8,
          'href',4]],(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['Rubix'])),(_l()(),i1.ɵted((null as any),['\'s landing page by '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'a',[['class','link link--name'],
          ['target','_blank']],[[8,'href',4]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,
      _v) => {
    var _co:i2.FooterComponent = _v.component;
    const currVal_0:any = _co.rubix;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _co.github;
    _ck(_v,4,0,currVal_1);
    const currVal_2:any = _co.author;
    _ck(_v,5,0,currVal_2);
  });
}
export function View_FooterComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-footer',
      ([] as any[]),(null as any),(null as any),(null as any),View_FooterComponent_0,
      RenderType_FooterComponent)),i1.ɵdid(49152,(null as any),0,i2.FooterComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const FooterComponentNgFactory:i1.ComponentFactory<i2.FooterComponent> = i1.ɵccf('admin-footer',
    i2.FooterComponent,View_FooterComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9mb290ZXIvZm9vdGVyLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQudHMuRm9vdGVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiQSBjbG9uZSBvZiA8YSBbaHJlZl09XCJydWJpeFwiIHRhcmdldD1cIl9ibGFua1wiIGNsYXNzPVwibGlua1wiPlJ1Yml4PC9hPidzIGxhbmRpbmcgcGFnZSBieSA8YSBbaHJlZl09XCJnaXRodWJcIiB0YXJnZXQ9XCJfYmxhbmtcIiBjbGFzcz1cImxpbmsgbGluay0tbmFtZVwiPnt7YXV0aG9yfX08L2E+IiwiPGFkbWluLWZvb3Rlcj48L2FkbWluLWZvb3Rlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsZ0RBQVc7TUFBQTtVQUFBLHFFQUErQzthQUFBLDJCQUFTO01BQW1CO1VBQUE7VUFBQSxnQkFBMkQ7OztJQUFuSTtJQUFILFdBQUcsU0FBSDtJQUE4RTtJQUFILFdBQUcsU0FBSDtJQUEyRDtJQUFBOzs7O29CQ0FqSjtNQUFBO2dDQUFBLFVBQUE7TUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./$$_gendir/src/app/footer/footer.component.ngfactory.ts